import axios, { AxiosInstance } from 'axios';
import { BACKEND_BASE_URL } from './ApiRoutes';

export const HANA_API_DOMAIN = 'hana-api.hanabitech.com';
export const UNAUTHORIZED_STATUS_CODE = 401;

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
  withCredentials: true,
});

export enum ERROR_STATUS_CODE {
  UNAUTHORIZED = UNAUTHORIZED_STATUS_CODE,
  FORBIDDEN = 403,
  TOO_MANY_REQUESTS = 429,
}
